import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('menus/', data));
/**
 * get list
 */
export const getTreeMenuList = data =>
    axios.$callAPI(() => axios.get('menus/search', { params: Object.assign(data) }));

export const getSubTreeMenuList = data =>
    axios.$callAPI(() => axios.get('menus/popup', { params: Object.assign(data) }));

/*export const getTreeMenuList = async data => {
    const lst = (await axios.$callAPI(() => axios.get('menus/search', { params: data }))).menus;

    // 构造menu专用的数据结构
    let result = lst.filter(m => m.parentId === '0');
    let Find = element => {
        element.children = lst.filter(m => m.parentId === element.id);
        element.title = element.name;
        element.selected = false;
        if (element.children.length > 0) {
            element.expand = true;
            FindChildren(element.children);
        }
    };
    let FindChildren = children => {
        children.forEach(Find);
    };
    FindChildren(result);

    return result;
};*/

/**
 * get menuInfo
 */
export const getMenuInfo = id => axios.$callAPI(() => axios.get('/menus/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('menus/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('menus/' + id));
/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('menus/', { data: ids }));
